import './Visual.css';
export var VisualOverlayCSS = '_9w5efw0-3-8-0';